import { render, staticRenderFns } from "./TeamMembers.vue?vue&type=template&id=e8eff812&scoped=true&"
import script from "./TeamMembers.vue?vue&type=script&lang=js&"
export * from "./TeamMembers.vue?vue&type=script&lang=js&"
import style0 from "./TeamMembers.vue?vue&type=style&index=0&id=e8eff812&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8eff812",
  null
  
)

export default component.exports